export default __webpack_public_path__ + "static/media/stone-guardian--side.9ee3edaa.jpg";